import React from 'react'
import {
	Drawer,
	Row,
	Space,
	Typography,
	List,
	Tag,
	Divider
} from 'antd'
import {
	CloseOutlined, CheckCircleFilled, CloseCircleFilled, MailOutlined
} from '@ant-design/icons'
import { groupBy } from 'lodash'
import dayjs from 'dayjs'
import { IPriceOfferSentEmail } from '../../../reducers/priceOffers/actions'
import { DEFAULT_DATE_WITH_TIME_FORMAT } from '../../../utils/enums'

interface SentEmailsDrawerProps {
	sentEmails: IPriceOfferSentEmail[]
	open: boolean
	onClose: () => void
}

const SentEmailsDrawer: React.FC<SentEmailsDrawerProps> = ({ sentEmails, open, onClose }) => {
	const groups = groupBy(sentEmails, (sentEmail) => sentEmail.sentToUserId ?? 'unknown')

	return (
		<Drawer
			title={
				<Row justify="space-between" align="middle">
					<Space>
						<CloseOutlined style={{ color: '#aaa' }} onClick={onClose} />
						<Typography.Text strong>Odoslané emaily</Typography.Text>
					</Space>
				</Row>
			}
			width={600}
			visible={open}
			onClose={onClose}
			closeIcon={null}
		>
			{Object.entries(groups).map(([sentToUserId, items]) => (
				<div key={sentToUserId} style={{ marginBottom: 24 }}>
					<Typography.Text strong>
						{items[0]?.sentToUserName || `Používateľ #${sentToUserId}`}
					</Typography.Text>

					<Divider style={{ margin: '8px 0' }} />

					<List
						itemLayout="vertical"
						dataSource={items}
						renderItem={(item) => (
							<List.Item key={item.id}>
								<Row justify="space-between" align="middle">
									<Space>
										{item.successfullySent
											? <Tag icon={<CheckCircleFilled />} color="green">Doručené</Tag>
											: <Tag icon={<CloseCircleFilled />} color="red">Nedoručené</Tag>}
										<Typography.Text type="secondary">
											{dayjs(item.sentAt).format(DEFAULT_DATE_WITH_TIME_FORMAT)}
										</Typography.Text>
									</Space>
								</Row>
								<div style={{ marginTop: 8 }}>
									<div><MailOutlined /> <Typography.Text>{item.sentToEmail}</Typography.Text></div>
									<div>
										<Typography.Text type="secondary">
											Odoslal: {item.sentByName || '-'}
										</Typography.Text>
									</div>
									{!item.successfullySent && item.errorMessage && (
										<Typography.Paragraph type="danger" style={{ marginTop: 4 }}>
											{item.errorMessage}
										</Typography.Paragraph>
									)}
								</div>
							</List.Item>
						)}
					/>
				</div>
			))}
		</Drawer>
	)
}

export default SentEmailsDrawer
